import { Component, OnDestroy, OnInit, } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'starter',
  templateUrl: 'starter.template.html'
})
export class StarterViewComponent implements OnDestroy, OnInit  {

public nav:any;

public constructor(private router: Router) {
  this.nav = document.querySelector('nav.navbar');
}

public ngOnInit():any {
  if (sessionStorage.getItem("UsuarioLog") == null) {
      this.router.navigateByUrl("login");
    }
  this.nav.className += " white-bg";
}


public ngOnDestroy():any {
  this.nav.classList.remove("white-bg");
}

}



// WEBPACK FOOTER //
// ./src/app/views/appviews/starterview.component.ts